module.exports = __webpack_public_path__ + "img/roomSvgImg.de3b5fcd.svg";